import React, { useState, useEffect } from 'react';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
// toast
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// moment
import moment from 'moment';
import { TimePicker } from 'antd';
import 'antd/dist/antd.css';
// COMPONENTS
import Header from '../../../components/header';
import BuyNow from '../../../components/buyNowSection';
import Carousel from '../../../components/carousel';
import Footer from '../../../components/footer';
import Input from '../../../components/input';
import Label from './labelWeatherComponent';
// ICONS
import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import _ from 'lodash';
// STYLES
import '../styles.css';
import { useHistory } from 'react-router';

const Weather = () => {
  const history = useHistory();
  const alreadyLoggedIn = localStorage.getItem('token');
  if (!alreadyLoggedIn) {
    history.push('/');
  }
  const [wakeUpTime, setWakeUpTime] = useState([]);
  const [show, setShow] = useState(false);
  const [weatherInfo, setWeatherInfo] = useState({
    wsonoff: '',
    location: '',
    wsmode: '',
  });
  const displayMode = ['Off', 'Forecasted High (*F)', 'Forecasted High (*C)'];
  const token = localStorage.getItem('token');
  const physicalId = localStorage.getItem('physicalId');
  const headers = {
    Accept: '*/*',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  };

  toast.configure();
  const softwareWeatherAPI = `control/${physicalId}/software/weather`;
  const wakeUpTimeAPI = `control/${physicalId}/software/weather-wakeup-time`;
  const handleSetLocation = (e) => {
    setWeatherInfo({ ...weatherInfo, location: e.target.value });
  };

  const handleSaveLocation = () => {
    fetch(softwareWeatherAPI, {
      method: 'PUT',
      headers,
      body: JSON.stringify({
        wsonoff: weatherInfo.wsonoff,
        location: weatherInfo.location,
        wsmode: weatherInfo.wsmode,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setWeatherInfo(response);
        toast.success('Location update', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        toast.error('Location not update', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleWeatherMode = (index) => {
    setWeatherInfo({ ...weatherInfo, wsmode: index });
    fetch(softwareWeatherAPI, {
      method: 'PUT',
      headers,
      body: JSON.stringify({
        wsonoff: weatherInfo.wsonoff,
        location: weatherInfo.location,
        wsmode: index,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setWeatherInfo(response);
        toast.success('Display mode update', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error('Display mode not update', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      });
  };

  // get location api
  useEffect(() => {
    fetch(softwareWeatherAPI, {
      method: 'GET',
      headers,
    })
      .then((response) => response.json())
      .then((response) => {
        setWeatherInfo({
          ...weatherInfo,
          location: response?.location,
          wsmode: response?.wsmode,
          wsonoff: response?.wsonoff,
        });
      })
      .catch((error) => console.log(error));
  }, []);

  // wakeuptime API
  useEffect(() => {
    fetch(wakeUpTimeAPI, {
      method: 'GET',
      headers: headers,
    })
      .then((response) => response.json())
      .then((response) => {
        console.log('RESPONSE', response);
        setWakeUpTime(response.weatherwakeuptime);
      })
      .catch((error) => console.log(error));
  }, []);

  // show time picker -> function
  const showPicker = () => {
    setShow(!show);
  };

  // wakeup time setter API
  const handleWakeupTime = (time, timeString) => {
    // console.log('change ', timeString.toString());
    const getTime = timeString?.toString();
    if (getTime) {
      fetch(wakeUpTimeAPI, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify({
          weatherwakeuptime: getTime,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          // console.log('WAKEUP_RESULT: ', response);
          if (response >= 500) {
            toast.error('Time not updated, try again', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              // theme: 'colored',
            });
          } else {
            setWakeUpTime(getTime);
            toast.success('Time updated successfully', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              // theme: 'colored',
            });
          }
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <div>
      <Header />
      <BuyNow />
      <Carousel />
      <section
        class='login-bg'
        style={{ backgroundImage: 'url(./images/login-bg.jpg)' }}
      >
        <div class='container'>
          <div class='container-sm-500'>
            <a href='/settings' class='back-arrow'>
              <FaArrowLeft />
            </a>
            <h2 class='text-left'>SELECT TIMEZONE</h2>
            <label class='custom-label mb-4'>SET LOCATION</label>
            <Input
              type='text'
              value={weatherInfo?.location}
              placeHolder='Location'
              onChange={(e) => handleSetLocation(e)}
              onBlur={handleSaveLocation}
            />
            <label class='custom-label mb-4'>DISPLAY MODE</label>
            <ul>
              {displayMode?.map((val, index) => {
                return (
                  <li index={`${val}_${index}`}>
                    <Label
                      index={index}
                      text={val}
                      wsmode={+weatherInfo?.wsmode}
                      onClick={(e) => handleWeatherMode(index)}
                    />
                  </li>
                );
              })}
            </ul>

            <p class='large-text mt-4'>
              Each morning before you wake up, the Droppler will estimate the
              high for the day so you can plan ahead.
              <br />
              <br />
              Real-time weather is currently not available.
            </p>
            <div class='text-center mt-5'>
              {show ? (
                <TimePicker
                  style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    marginBottom: 10,
                    marginTop: 0,
                    color: '#ffffff',
                    alignItems: 'center',
                    width: '50%',
                  }}
                  onChange={handleWakeupTime}
                  // onChange={(value) => {
                  //   setInputTime(moment(value).format('HH:mm').toString());
                  // }}
                  suffixIcon={false}
                  inputReadOnly={true}
                  showNow={false}
                  format='HH:mm'
                  autoFocus={true}
                  placeholder={wakeUpTime}
                />
              ) : null}
              <p class='large-text'>
                Wakeup time: {wakeUpTime ? wakeUpTime : 'No device found'}
              </p>
              <button class='submit-btn' onClick={showPicker}>
                Set Wakeup Time
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
export default Weather;
